<script setup lang="ts">
import { capitalize, computed, onUnmounted } from "vue";

import Tooltip from "~/components/dumb/Tooltip.vue";
import { Placement } from "~/shared/enums";
import { makeRelativeTimeForActivityItemRef } from "~/utils/time";

const props = defineProps<{
  at: string;
  veryShort?: boolean;
  prefix?: string;
  showPreposition?: boolean;
  titleCase?: boolean;
  tooltipTop?: boolean;
  cursorPointer?: boolean;
  inheritSize?: boolean;
  inheritColor?: boolean;
}>();

const atPretty = makeRelativeTimeForActivityItemRef(
  computed(() => props.at),
  props.veryShort
);
const short = computed(() => (props.titleCase ? capitalize(atPretty.value.short) : atPretty.value.short));

onUnmounted(() => {
  atPretty.value.destroy();
});
</script>

<template>
  <span v-if="showPreposition && atPretty.preposition" class="text-lt">{{ atPretty.preposition }}&nbsp;</span>
  <Tooltip :placement="tooltipTop ? Placement.TOP : Placement.BOTTOM" :text="atPretty.full" class="w-max shrink-0">
    <span
      class="tabular-nums select-none"
      :class="[
        !inheritSize && 'text-xs/[22px]',
        !inheritColor && 'text-vlt',
        cursorPointer ? 'cursor-pointer' : 'cursor-default',
      ]">
      {{ `${prefix ? `${prefix} ` : ""}${short}` }}
    </span>
  </Tooltip>
</template>
